/**
 * 404 PAGE TEMPLATE
 *
 *
 * @version 0.1
 */

import React from 'react';
import { FormattedMessage } from 'react-intl';

function Page404() {

    return (

        <div className="error-404">

            <div className="error-404__title">
                <FormattedMessage id="General_CoreFunctionality_Error_error.404Title" />
            </div>

            <div className="error-404__message">
                <FormattedMessage id="General_CoreFunctionality_Error_error.message" />
            </div>

        </div>

    );

}

export default Page404;


// WEBPACK FOOTER //
// ./src/scripts/pages/ErrorPage/templates/ErrorPage.404.jsx